import { render, staticRenderFns } from "./ModalTutors.vue?vue&type=template&id=4313d11e"
import script from "./ModalTutors.vue?vue&type=script&lang=js"
export * from "./ModalTutors.vue?vue&type=script&lang=js"
import style0 from "./ModalTutors.vue?vue&type=style&index=0&id=4313d11e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports